import React, {useCallback, useContext, useState, useEffect} from 'react';
import {NavLink, useNavigate} from 'react-router-dom';

import {ContextAuth} from "../../../common/context/context-auth";

import {useFrom} from '../../../common/hook/form';
import {validatorNotEmpty} from '../../../common/util/validators';
import FormElement from '../../../common/component/FormElement/FormElement';
import showValidators from '../../../common/util/show-validators';

import {useHttpClient} from '../../../common/hook/http';

import {useToast} from '../../../common/hook/toast';

import setNativeValue from '../../../common/util/set-native-value';

import {Modal, Row, Button, Spinner, Form} from 'react-bootstrap';

import './MicaCoinLottery.scss';
import * as IconFi from "react-icons/fi";

const ModalMicaCoinLottery = props => {
    const {callAPI} = useHttpClient()
    const navigate = useNavigate()
    const {callToast} = useToast()
    const auth = useContext(ContextAuth)

    // ------------------------------------------------------------------------------------------------ on show and hide

    const handlePopstate = useCallback(() => {

        if (document.querySelectorAll('.modal').length < 2)
            window.removeEventListener('popstate', handlePopstate)

        props.onHide()

    }, [])

    const onShowHandler = () => {

        document.getElementById('modalMicaCoinLottery').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate(`#modalMicaCoinLottery`)
        window.addEventListener('popstate', handlePopstate);

    }

    const onHideHandler = () => {

        navigate(-1)

    }

    // -----------------------------------------------------------------------------------------------------------------

    const renderMessage = () => {

        if (props.data.expired === true)
            return <>این قرعه کشی پایان یافته است.</>
        else if (props.data.started === false)
            return <>هنوز زمان شرکت در قرعه کشی نرسیده است.</>
        else if (props.data.status === false)
            return <>امکان شرکت در این قرعه کشی برای شما وجود ندارد.<br/>جهت شرکت در این قرعه کشی، حداقل تعداد <span className="px-1">{props.data.mica_coin_count}</span> کوین مورد نیاز است. <NavLink to={'/mica-coin'} className="text-decoration-none">(راهنما)</NavLink></>
        else if (props.data.status === true)
            return <>جهت شرکت در این قرعه کشی تعداد <span className="px-1">{props.data.mica_coin_count}</span> کوین به ازای هر کد قرعه کشی از حساب شما کسر می گردد. آیا تایید می کنید؟</>

    }

    // -----------------------------------------------------------------------------------------------------------------

    const [spinnerShow, setSpinnerShow] = useState(false)

    const [formState, inputHandler] = useFrom({
        formMicaCoinLotteryCount: {
            value: '1',
            isValid: true
        }
    }, true);

    const formSubmitHandler = async event => {

        event.preventDefault();

        if (formState.isValid) {

            setSpinnerShow(true);

            const values = {}

            for (const item in formState.inputs) {
                let tempKey = item.split('formMicaCoinLottery')[1];
                tempKey = tempKey.charAt(0).toLowerCase() + tempKey.slice(1);
                values[tempKey] = formState.inputs[item].value
            }

            values['lottery'] = props?.data?.id

            try {
                const responseData = await callAPI(
                    'crm/registerLottery',
                    'POST',
                    JSON.stringify(values),
                )

                if (responseData.message)
                    callToast('secondary', null, null, responseData.message);
                else {

                    callToast('secondary', null, null, 'با موفقیت در قرعه کشی شرکت کردید');

                    setSpinnerShow(false);

                    props.onHide(responseData.result)

                }

            } catch (err) {
                setSpinnerShow(false);
            }

        } else showValidators(formState.inputs)

    }

    // -----------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        if (Number(formState.inputs.formMicaCoinLotteryCount.value) > Math.floor(auth.user.availablePoint / props?.data?.mica_coin_count))
            setNativeValue('formMicaCoinLotteryCount', Math.floor(auth.user.availablePoint / props?.data?.mica_coin_count))

    }, [formState.inputs.formMicaCoinLotteryCount.value])

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <Modal id="modalMicaCoinLottery" aria-labelledby="modalMicaCoinLotteryTitle" {...props} fullscreen backdrop={false} onHide={onHideHandler} onShow={onShowHandler} className="ltr bg-body" dialogClassName="rtl" contentClassName="container-lg px-0">
            <Modal.Header className="position-sticky top-0">
                <Button variant="link" onClick={onHideHandler} className="my-md-1 text-reset border-0 btn-icon d-md-none"><IconFi.FiArrowRight size={24} className="sw-1 m-2"/></Button>
                <Modal.Title className="me-4 pe-3 flex-grow-1 text-center text-md-start fs-5 text-truncate">قرعه کشی</Modal.Title>
                <Button variant="link" onClick={onHideHandler} className="my-md-1 text-reset border-0 btn-icon d-none d-md-inline-block"><IconFi.FiX size={24} className="sw-1 m-2"/></Button>
            </Modal.Header>
            {
                props.data ? (
                    <>
                        <Modal.Body className="py-0">
                            <Row>
                                <div className="ratio ratio-16x9 bg-primary">
                                    <span className="p-4 d-flex flex-column justify-content-end align-items-start text-accent">
                                        <span className="fs-5 mb-1">از <span className="ltr d-inline-block px-1">{props.data.startShamsi}</span> تا <span className="ltr d-inline-block px-1">{props.data.endShamsi}</span></span>
                                        <span className="h3 fw-bold mb-sm-3">{props.data.title}</span>
                                        <span className="fs-5 text-white d-none d-sm-block">تاریخ قرعه کشی {props.data.lotteryShamsi}</span>
                                    </span>
                                </div>
                                <div className="fs-5 text-accent pt-4 px-4 d-sm-none">تاریخ قرعه کشی {props.data.lotteryShamsi}</div>
                                {
                                    !!props.data.description && (
                                        <div className="pt-4 px-4">{props.data.description}</div>
                                    )
                                }
                                <div className="pt-4 pb-3 px-4">{renderMessage()}</div>
                                <Form id="formMicaCoinLottery" onSubmit={formSubmitHandler} autoComplete="off" className="ps-4">
                                    <FormElement component="INPUT" type="text" id="formMicaCoinLotteryCount" name="count" className="ltr text-left ls-1 font-fa"
                                                 label={`تعداد (حداکثر ${Math.floor(auth.user.availablePoint / props.data.mica_coin_count)})`}
                                                 validators={[validatorNotEmpty()]} textInvalid="تعداد را وارد نمایید" onInput={inputHandler} editValue={formState.inputs.formMicaCoinLotteryCount.value} maxLength="3" digit inputMode="numeric"/>
                                </Form>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer className="rtl">
                            {
                                props.data.status && !props.data.expire ? (
                                    <>
                                        <Button variant="link" className="col text-decoration-none fw-500" onClick={onHideHandler}>
                                            انصراف
                                        </Button>
                                        <Button type="submit" className="col btn-loading" disabled={spinnerShow} form="formMicaCoinLottery">
                                            <Spinner as="i" animation="border" size="sm" className={spinnerShow && 'opacity-100'}/>
                                            <span className="text-nowrap">تایید و شرکت در قرعه کشی</span>
                                        </Button>
                                    </>
                                ) : (
                                    <Button variant="link" className="col text-decoration-none fw-500" onClick={onHideHandler}>
                                        بستـن
                                    </Button>
                                )
                            }
                        </Modal.Footer>
                    </>
                ) : (
                    <></>
                )
            }
        </Modal>
    )
}

export default ModalMicaCoinLottery;